/* global insideFrontInterface */

const closeChatPane = () => {
    if (insideFrontInterface && insideFrontInterface.chat && insideFrontInterface.chat.closeChatPane &&
        typeof insideFrontInterface.chat.closeChatPane === 'function') {
        insideFrontInterface.chat.closeChatPane();
    }
};

module.exports = {
    closeChatPane
};
